export default __webpack_public_path__ + "static/media/2nd.2cf68a7e.png";